import React from 'react'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import CustomSlider from '../../components/custom-slider/custom-slider'
import Slider from "react-slick";
import SectionTC from '../../components/section-tc/section-tc'
import styled from 'styled-components'
import gallery01 from '../../assets/img/gallery_01.png'
import gallery02 from '../../assets/img/gallery_02.png'
import gallery03 from '../../assets/img/gallery_03.png'
import ItemDetailService from './components/item-service-detail/item-detail-about/item-detail-about'
import ItemAboutDetail from './components/item-service-detail/item-service-about'

const ContainerImage = styled.div`
  padding-left: 6px;
  padding-right: 6px;

  > img {
    width: 100%;
    height: 100%;
  }
`
const ContainerSlider = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
`
const ContainerDetailService = styled.div`
  width: 100%;  
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`
const customSliderStyles = `
   background: #F2F2F2;
   border-radius: 15px;
   padding-top: 20px;
   padding-bottom: 20px;
`

const AboutUs: React.FunctionComponent = () => {
  const sliderGalleryRef = React.useRef<Slider>(null);

  const responsive = [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 920,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 728,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }
  ]

  return (
    <Layout>
        <HeaderOptions></HeaderOptions>
        <SectionTC>
          <ItemAboutDetail />
        </SectionTC>
        <ContainerSlider>
          <CustomSlider
            sliderRef={sliderGalleryRef}
            size={5}
            customSlidesToShow={4}
            customResponsive={responsive}
            className={customSliderStyles}
          >
            <ContainerImage><img src={gallery01} alt='gallery_01'/></ContainerImage>
            <ContainerImage><img src={gallery02} alt='gallery_02'/></ContainerImage>
            <ContainerImage><img src={gallery03} alt='gallery_03'/></ContainerImage>
            <ContainerImage><img src={gallery01} alt='gallery_01'/></ContainerImage>
            <ContainerImage><img src={gallery02} alt='gallery_02'/></ContainerImage>
          </CustomSlider>
        </ContainerSlider>
        <SectionTC>
          <ContainerDetailService>
            <ItemDetailService />
            <ItemDetailService />
            <ItemDetailService />
          </ContainerDetailService>
        </SectionTC>
    </Layout>
  )
}

export default AboutUs